$( document ).on ( 'areaReady' , function ( event ) {
    $( '.set-translate-preview' , event.target ).click ( function () {
        var mode = $( this ).attr ( 'data-preview_mode' ) ;
    
        dcg_ExecuteModule ( 'translate' , { action: 'set_preview' , mode: mode } , function () {
            document.location.reload () ;
        } ) ;
    } ) ;
} ) ;